interface InfiniteScrollTextProps {
  text: string;
  className?: string;
  /** Scroll direction. Default "left". */
  direction?: "left" | "right";
}

export function InfiniteScrollText({ text, className = "", direction = "left" }: InfiniteScrollTextProps) {
  // Repeat the text multiple times to ensure smooth continuous scroll
  const repeatedText = Array(20).fill(text).join("  ");

  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div className={`inline-flex ${direction === "right" ? "animate-scroll-reverse" : "animate-scroll"}`} style={{ color: '#C0E1F9' }}>
        <span className="inline-block pr-4" style={{ color: '#C0E1F9' }}>{repeatedText}</span>
        <span className="inline-block pr-4" style={{ color: '#C0E1F9' }}>{repeatedText}</span>
      </div>
    </div>
  );
}
